// importeer hier alle scripts die je maakt
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Lenis from "lenis";
import { productFilter } from "./product-filter.js";
import { eventsFilter } from "./components/eventsFilter.js";
import { eventPersons } from "./components/eventPersons.js";
import "./components/masonry.js";
import "./helpers/lazyImgs.js";
import "./accessibility.js";
import "./iubenda.js";
import "./helpers/strip-tracking-params.js";

document.addEventListener("DOMContentLoaded", () => {
  window.Alpine = Alpine;

  // Only start Alpine if it hasn't already been started
  if (typeof Alpine.start === "function" && !Alpine.isStarted) {
    Alpine.plugin(collapse);
    Alpine.plugin(focus);
    Alpine.data('productFilter', productFilter);
    Alpine.data('eventsFilter', eventsFilter);
    Alpine.data('eventPersons', eventPersons);
    Alpine.start();
    Alpine.isStarted = true;
  }
});

// Check for reduced motion preference
const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

// Enhanced Fancybox configuration for accessibility
Fancybox.bind("[data-fancybox]", {
  Hash: false,
  trapFocus: true,
  autoFocus: true,
  placeFocusBack: true,
  dragToClose: !prefersReducedMotion,
  l10n: {
    CLOSE: "Close",
    NEXT: "Next",
    PREV: "Previous",
    ZOOM: "Zoom",
  },
});

Fancybox.bind("[data-fancybox='gallery']", {
  Hash: false,
  trapFocus: true,
  autoFocus: true,
  placeFocusBack: true,
  dragToClose: !prefersReducedMotion,
});

const lenis = new Lenis({
  lerp: prefersReducedMotion ? 1 : 0.2,
  wheelMultiplier: prefersReducedMotion ? 1 : 0.8,
  infinite: false,
  gestureOrientation: "both",
  normalizeWheel: false,
  syncTouch: false,
  autoRaf: !prefersReducedMotion,
  smoothWheel: !prefersReducedMotion,
});

// Add reCAPTCHA notice to all Formie forms
document.querySelectorAll(".fui-form").forEach((form) => {
  if (!window.recaptchaNotice) return;
  const notice = document.createElement("p");
  notice.className = "recaptcha-notice";
  notice.innerHTML = window.recaptchaNotice;

  const privacyField = form.querySelector('[data-fui-input-type="agree"]')?.closest(".fui-row");
  if (privacyField) {
    privacyField.before(notice);
  } else {
    form.appendChild(notice);
  }
});

import "./helpers/geolocation.js";
import "./components/sliders.js";
import "./sector.js";
import "./helpers/boxSizing.js";
import "./favicon.js";
import "./components/leaflet.js";
import "./components/listLogic.js";
import "./components/forms.js";
import "./components/kalibratie-calc.js";
import "./components/roi-calc.js";
import "./components/see-pass.js";
import "./components/sharing.js";
import "./components/productCompare.js";
import "./components/search-tracking.js";
